import AdBanner from '@/components/AdBanner'
import { AdBox, AdContent } from '@/components/AdContent'
import AppDownloadWrapper from '@/components/AppDownloadWrapper'
import ComponentMetricsBoundary from '@/components/ComponentMetricsBoundary/ComponentMetricsBoundary'
import EmailSignUp from '@/components/EmailSignUp'
import FAQ from '@/components/FAQ'
import LayoutComponentWrapper from '@/components/LayoutComponentWrapper'
import PromoBanners from '@/components/MerchModuleWrapper/PromoBanners'
import SEOLinks from '@/components/SEOLinks'
import LinksWidget from '@/components/SkyMondeSeo/LinksWidget'
import TripActivity from '@/components/TripActivity/TripActivity'
import WhyPricelineBanner from '@/components/WhyPricelineBanner'
import { REASONS_HOTELS_LP } from '@/constants/reasons'
import SEOPRODUCTLINKS from '@/constants/seo-product-links'
import useBootstrapData from '@/hooks/useBootstrapData'
import {
  isCollectionOfIArticleType,
  isCollectionOfIMerchModule,
} from '@/shared-utils/content-model-type-guards'
import { useContentfulWithPredicate } from '@pcln/contentful-components'
import { Box, Container } from 'pcln-design-system'
import { useState } from 'react'
import ExpressDealPromo from '../ExpressDeal/ExpressDealPromo'

const { GLOBAL, USA, EUROPE, ASIA, INTERNATIONAL } = SEOPRODUCTLINKS.HOTELS.links.exploreDeals

function HotelsContent() {
  const toutBanners = useContentfulWithPredicate('toutBanners', isCollectionOfIMerchModule)
  const articles = useContentfulWithPredicate('articles', isCollectionOfIArticleType)

  const promoItems = toutBanners?.items || ([] as const)
  const [isTripActivityVisible, setIsTripActivityVisible] = useState(false)
  const { skymondeSEO } = useBootstrapData()

  return (
    <Container size='xl' mb={5}>
      <Box mt={[0, null, 4]}>
        <TripActivity setIsVisible={setIsTripActivityVisible} productType={['STAY']} pageName='landing' />
      </Box>
      <LayoutComponentWrapper topGap>
        {!isTripActivityVisible && <WhyPricelineBanner content={REASONS_HOTELS_LP} />}
        <AdContent>
          <AdBox type='primary'>
            <div id='div-gpt-ad-1509978848821-0' />
          </AdBox>
          <AdBox type='secondary'>
            <div id='div-gpt-ad-1509978930813-0' />
          </AdBox>
          <AdBox type='tertiary'>
            <div id='div-gpt-ad-1509129580404-0' />
          </AdBox>
        </AdContent>
        <ComponentMetricsBoundary componentId='EmailSignUp'>
          <EmailSignUp appCode='DESKTOP' sourceId='LANDING_HOTEL' />
        </ComponentMetricsBoundary>
        <ExpressDealPromo />
        <ComponentMetricsBoundary componentId='PromoBanners'>
          <PromoBanners merchModules={promoItems} />
        </ComponentMetricsBoundary>
        <Box>
          <AppDownloadWrapper />
        </Box>
        <AdBanner>
          <div id='div-gpt-ad-1509129866793-0' />
        </AdBanner>
        {articles?.items?.length ? <FAQ articles={articles} /> : null}
        {skymondeSEO ? (
          <ComponentMetricsBoundary componentId='LinksWidget'>
            <LinksWidget data={skymondeSEO} />
          </ComponentMetricsBoundary>
        ) : (
          <>
            {[USA, EUROPE, ASIA, INTERNATIONAL, GLOBAL].map((location) => (
              <SEOLinks key={location.action} caption={location.caption} links={location.items} />
            ))}
          </>
        )}
      </LayoutComponentWrapper>
    </Container>
  )
}

export default HotelsContent
